/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Display_Height_LabelInputs */

const en_options_display_height_label = /** @type {(inputs: Options_Display_Height_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Display Height (Lines)`)
};

const fr_options_display_height_label = /** @type {(inputs: Options_Display_Height_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hauteur d'affichage (lignes)`)
};

const de_options_display_height_label = /** @type {(inputs: Options_Display_Height_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzeigehöhe (Zeilen)`)
};

const it_options_display_height_label = /** @type {(inputs: Options_Display_Height_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altezza di visualizzazione (linee)`)
};

const ru_options_display_height_label = /** @type {(inputs: Options_Display_Height_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Высота отображения (строк)`)
};

const es_options_display_height_label = /** @type {(inputs: Options_Display_Height_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altura de la pantalla (líneas)`)
};

const zh_cn2_options_display_height_label = /** @type {(inputs: Options_Display_Height_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`显示高度（行）`)
};

const ja_options_display_height_label = /** @type {(inputs: Options_Display_Height_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表示高さ（行）`)
};

const hi_options_display_height_label = /** @type {(inputs: Options_Display_Height_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डिस्प्ले की ऊंचाई (लाइनें)`)
};

const pt_pt2_options_display_height_label = /** @type {(inputs: Options_Display_Height_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altura de exibição (linhas)`)
};

/**
* | output |
* | --- |
* | "Display Height (Lines)" |
*
* @param {Options_Display_Height_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_display_height_label = /** @type {((inputs?: Options_Display_Height_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Display_Height_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_display_height_label(inputs)
	if (locale === "de") return de_options_display_height_label(inputs)
	if (locale === "it") return it_options_display_height_label(inputs)
	if (locale === "ru") return ru_options_display_height_label(inputs)
	if (locale === "es") return es_options_display_height_label(inputs)
	if (locale === "zh-CN") return zh_cn2_options_display_height_label(inputs)
	if (locale === "ja") return ja_options_display_height_label(inputs)
	if (locale === "hi") return hi_options_display_height_label(inputs)
	if (locale === "pt-PT") return pt_pt2_options_display_height_label(inputs)
	return en_options_display_height_label(inputs)
});